import React from "react";
import InputBase from "@mui/material/InputBase";
import useClasses from "../../../useClasses";

const styles = (theme) => ({
  root: {
    alignItems: "center",
  },
  input: {
    flex: 1,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  title: {
    fontFamily: theme.typography.h6.fontFamily,
    fontWeight: theme.typography.h6.fontWeight,
    fontSize: theme.typography.h6.fontSize,
    lineHeight: theme.typography.h6.lineHeight,
    letterSpacing: theme.typography.h6.letterSpacing,
    paddingTop: theme.spacing(1),
  },
  body: {
    fontFamily: theme.typography.body1.fontFamily,
    fontWeight: theme.typography.body1.fontWeight,
    fontSize: theme.typography.body1.fontSize,
    lineHeight: theme.typography.body1.lineHeight,
    letterSpacing: theme.typography.body1.letterSpacing,
  },
});

function InputBox(props) {
  const classes = useClasses(styles);

  const handleChange = (e) => {
    props.setTextInput(e.target.value);
  };

  return (
    <div className={classes.root}>
      <InputBase
        className={classes.input}
        placeholder={props.placeholder}
        inputProps={{
          "aria-label": props.placeholder,
          className: props.customStyle === "title" ? classes.title : classes.body,
         
        }}
        value={props.textInput}
        fullWidth
        multiline
        onChange={handleChange}
        autoFocus={props.autoFocus}
      />
    </div>
  );
}

export default InputBox;
